var translate = function translate() {
  throw new Error("You must initialize the component library with a `translate` function to translate text!");
};
/**
 *
 * Takes either multiple arguments or a translatable obj.
 * Translatable object accepts the following keys:
 *   {str, fallback, subs, tmpText, text},
 *
 */


var defaultTranslate = function defaultTranslate() {
  return translate.apply(void 0, arguments);
};

export default defaultTranslate;
export function setTranslateFunction(fn) {
  translate = fn;
}
//# sourceMappingURL=translate.js.map